module.exports = __webpack_public_path__ + "media/bootstrap-icons/bar-chart-158dc33a.svg";